import classes from './ChatWidget.module.scss'
import { ChatForm, FormOption } from './types'

interface Props {
  form: ChatForm
  onSelect: (option: FormOption) => void
  disabled?: boolean
}

export default function StepForm({ form, onSelect, disabled }: Props) {
  const { stepCurrent, stepTotal, percent, stepLabel, prompt, options } = form
  const hasProgress = stepCurrent != null && stepTotal != null
  const pct =
    typeof percent === 'number'
      ? Math.max(0, Math.min(100, percent))
      : hasProgress
      ? Math.round((stepCurrent! / stepTotal!) * 100)
      : 0

  return (
    <div className={classes.stepForm}>
      {(hasProgress || stepLabel) && (
        <div className={classes.stepHead}>
          <span className={classes.stepLabel}>
            {hasProgress ? `Adım ${stepCurrent}/${stepTotal}` : ''}
            {hasProgress && stepLabel ? ': ' : ''}
            {stepLabel || ''}
          </span>
          {typeof percent === 'number' || hasProgress ? (
            <span className={classes.stepPercent}>%{pct}</span>
          ) : null}
        </div>
      )}

      {(hasProgress || typeof percent === 'number') && (
        <div className={classes.stepBar}>
          <div className={classes.stepBarFill} style={{ width: `${pct}%` }} />
        </div>
      )}

      {prompt && <div className={classes.stepPrompt}>{prompt}</div>}

      <div className={classes.stepOptions}>
        {options.map(opt => (
          <button
            key={opt.value}
            type='button'
            className={classes.stepOption}
            onClick={() => onSelect(opt)}
            disabled={disabled}
          >
            <span className={classes.stepRadio} />
            <span className={classes.stepOptionBody}>
              <span className={classes.stepOptionLabel}>{opt.label}</span>
              {opt.description && (
                <span className={classes.stepOptionDesc}>{opt.description}</span>
              )}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
